var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApproved = function SvgApproved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 28C56 12.535 43.465 0 28 0 12.536 0 0 12.536 0 28s12.536 28 28 28c15.465 0 28-12.535 28-28Zm-4.086 0c0 13.208-10.705 23.914-23.914 23.914C14.793 51.914 4.086 41.207 4.086 28S14.793 4.086 28 4.086c13.209 0 23.914 10.706 23.914 23.914Zm-37.014.601a2.043 2.043 0 0 1 2.89 0l5.422 5.423 15.037-15.038a2.043 2.043 0 1 1 2.89 2.89L24.657 38.358a2.043 2.043 0 0 1-2.89 0L14.9 31.49a2.043 2.043 0 0 1 0-2.89Z",
    fill: "currentColor"
  })));
};
export { SvgApproved as ReactComponent };
export default __webpack_public_path__ + "f44d5ccdbbfc77189b94a97af7175b28.svg";